<h1 class="title">Generate Transaction Activity</h1>

<button class="close-button" (click)="activeModal.close()">
  <rkt-icon name="times"></rkt-icon>
</button>

<div class="details-page-edit-form">
  <form [formGroup]="transactionActivityForm">
    <rkt-form [form]="transactionActivityForm" [fields]="transactionActivityFormFields" [model]="formModel"></rkt-form>
  </form>
</div>

@if (submitError) {
  <div class="details-page-edit-form-error">{{ submitError }}</div>
}

<div class="buttons">
  <button rktButton type="button" btnType="tertiary" (click)="onFormReset()">Reset</button>
  <button rktButton type="submit" (click)="onSave()" [disabled]="isLoading || transactionActivityForm.invalid">Submit</button>
</div>
